import http from './http';

export function themeColors({ name = 'zorpay' } = {}, config = {}) {
  return http.postJson('/label/info', { name }, {
    ...config,
    meta: {
      ...(config.meta || {}),
      showLoading: false,
      disablePostEncrypt: true
    }
  });
}

export function indexBanner(config = {}) {
  return http.postJson('/index/banner', {}, config);
}

export function advertList({ address, pageNum = 1, pageSize = 10, adType }) {
  return http.postJson('/advert/list', {
    address,
    pageNum,
    pageSize,
    adType
  });
}

export function dappInfo({ address } = {}, config = {}) {
  return http.postJson('/dapp/info', {
    address
  }, config);
}
